import React from 'react';
import {
  Card,
  CardContent,
  Grid,
  LinearProgress,
  Stack,
  Typography,
} from '@mui/material';

function UserStats({ stats, requirements, year, inline = false, showEquipmentInspectorHours = false }) {
  const totalHours = stats?.total_hours || 0;
  const trainerHours = stats?.trainer_hours || 0;
  const equipmentInspectorHours = stats?.equipment_inspector_hours || 0;
  const totalTarget = requirements?.total || 72;
  const trainerTarget = requirements?.trainer || 54;

  const roundHours = (value) => {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) {
      return 0;
    }

    return Math.round(numeric);
  };

  const totalProgress = (totalHours / totalTarget) * 100;
  const trainerProgress = (trainerHours / trainerTarget) * 100;

  const formatHours = (value) => {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) {
      return '0';
    }

    return String(Math.round(numeric));
  };

  const cards = [
    {
      title: `Gesamtstunden ${year || new Date().getFullYear()}`,
      value: `${roundHours(totalHours)}/${roundHours(totalTarget)}`,
      remaining: roundHours(Math.max(0, totalTarget - totalHours)),
      progress: totalProgress,
      color: 'primary',
    },
    {
      title: 'Stunden mit Lehrhöhenretter',
      value: `${roundHours(trainerHours)}/${roundHours(trainerTarget)}`,
      remaining: roundHours(Math.max(0, trainerTarget - trainerHours)),
      progress: trainerProgress,
      color: 'success',
    },
  ];

  return (
    <Grid container spacing={{ xs: 1.25, sm: 2 }} sx={inline ? { width: '100%' } : undefined}>
      {cards.map((item) => (
        <Grid item xs={12} sm={6} md={showEquipmentInspectorHours ? 5 : 6} key={item.title}>
          <Card sx={{ height: '100%', borderRadius: 3, border: 1, borderColor: 'divider' }}>
            <CardContent sx={{ p: { xs: 1.5, sm: 2 } }}>
              <Stack spacing={1}>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600, fontSize: { xs: '0.78rem', sm: '0.875rem' } }}>
                  {item.title}
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 700, fontSize: { xs: '1.3rem', sm: '1.5rem' } }}>
                  {item.value}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ fontSize: { xs: '0.72rem', sm: '0.75rem' } }}>
                  {`${item.remaining} Stunden bis zum Ziel`}
                </Typography>
                <Stack spacing={0.5}>
                  <LinearProgress
                    color={item.color}
                    variant="determinate"
                    value={Math.min(item.progress, 100)}
                    sx={{ height: 9, borderRadius: 999 }}
                  />
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: { xs: '0.72rem', sm: '0.75rem' } }}>
                    {Math.round(item.progress)}%
                  </Typography>
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      ))}
      {showEquipmentInspectorHours ? (
        <Grid item xs={12} sm={12} md={2}>
          <Card sx={{ height: '100%', borderRadius: 3, border: 1, borderColor: 'divider' }}>
            <CardContent sx={{ p: { xs: 1.25, sm: 1.5 }, height: '100%', minHeight: 108 }}>
              <Stack spacing={0.5} justifyContent="center" alignItems="center" sx={{ height: '100%', textAlign: 'center' }}>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontWeight: 600, fontSize: { xs: '0.75rem', sm: '0.82rem' }, lineHeight: 1.1 }}
                >
                  Geräteprüfer
                  <br />
                  stunden
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 700, fontSize: { xs: '1.2rem', sm: '1.4rem' }, mt: 0.25, lineHeight: 1 }}>
                  {formatHours(equipmentInspectorHours)}
                </Typography>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      ) : null}
    </Grid>
  );
}

export default UserStats;
